/* unplugin-vue-components disabled */import { render } from "./WatermarkerView.vue?vue&type=template&id=4f2324b7&scoped=true"
import script from "./WatermarkerView.vue?vue&type=script&lang=js"
export * from "./WatermarkerView.vue?vue&type=script&lang=js"

import "./WatermarkerView.vue?vue&type=style&index=0&id=4f2324b7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2324b7"]])

export default __exports__